import { render, staticRenderFns } from "./view.vue?vue&type=template&id=3907c425&scoped=true&lang=pug"
import script from "./view.vue?vue&type=script&lang=js"
export * from "./view.vue?vue&type=script&lang=js"
import style0 from "./view.vue?vue&type=style&index=0&id=3907c425&scoped=true&lang=scss"
import style1 from "./view.vue?vue&type=style&index=1&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3907c425",
  null
  
)

export default component.exports